import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import format from 'string-template';

import { FieldLabels } from '../../../../../../../../../Model/CoachInfo';
import { DateFormat } from '../../../../../../../../../utils/date';

import {
  InfoSection,
  InfoRow,
  InfoLabel,
  InfoValue,
  PricingTable,
  PricingTh,
  PricingTd,
} from './styles';
import texts from './texts';

const StructuredCoachInfo = ({
  data,
  assignedCAMName,
  isEnrolledAt,
}) => (
  <InfoSection>
    {assignedCAMName && (
      <InfoRow>
        <InfoLabel>{texts.assignedCAM}</InfoLabel>
        <InfoValue>{assignedCAMName}</InfoValue>
      </InfoRow>
    )}
    {isEnrolledAt && (
      <InfoRow>
        <InfoLabel>{texts.isEnrolledAt}</InfoLabel>
        <InfoValue>{moment(isEnrolledAt).format(DateFormat.DATE_FORMAT_TIME_MINUTES)}</InfoValue>
      </InfoRow>
    )}
    {Object.values(FieldLabels).map((key) => {
      if (!data[key]) return null;
      if (key === FieldLabels.Pricing && Array.isArray(data[key])) {
        return (
          <InfoRow key={key}>
            <InfoLabel $marginTop={10}>{`${texts.fieldLabels[key]}`}</InfoLabel>
            <InfoValue>
              <PricingTable>
                <thead>
                  <tr>
                    <PricingTh>{texts.package}</PricingTh>
                    <PricingTh>{texts.price}</PricingTh>
                    <PricingTh>{texts.comments}</PricingTh>
                  </tr>
                </thead>
                <tbody>
                  {data.pricing.map(({ month, price, comments }) => {
                    let formattedMonth = month;
                    if (month && !Number.isNaN(Number(month))) {
                      formattedMonth = format(texts.months, { package: month });
                    }
                    return (
                      <tr key={month}>
                        <PricingTd>{formattedMonth}</PricingTd>
                        <PricingTd>{price || texts.emptyValue}</PricingTd>
                        <PricingTd>{comments || texts.emptyValue}</PricingTd>
                      </tr>
                    );
                  })}
                </tbody>
              </PricingTable>
            </InfoValue>
          </InfoRow>
        );
      }
      return (
        <InfoRow key={key}>
          <InfoLabel>{`${texts.fieldLabels[key]}`}</InfoLabel>
          <InfoValue>{data[key]}</InfoValue>
        </InfoRow>
      );
    })}
  </InfoSection>
);

StructuredCoachInfo.propTypes = {
  data: PropTypes.object.isRequired,
  assignedCAMName: PropTypes.string,
  isEnrolledAt: PropTypes.instanceOf(Date),
};

StructuredCoachInfo.defaultProps = {
  assignedCAMName: '',
  isEnrolledAt: null,
};

export default StructuredCoachInfo;
